import type { ChartType } from '../types'

// The chart types the recharts registry (InsightChart) can actually render. There is no
// Vega-Lite / long-tail fallback — the contract (contract.py Literal + types.ts ChartType)
// only ever emits these five, and the renderer fails honestly on anything else (AUDIT #9).
export const SUPPORTED_CHART_TYPES: readonly ChartType[] = ['barH', 'barV', 'line', 'groupedH', 'donut']

export function isSupportedChartType(t: string): boolean {
  return (SUPPORTED_CHART_TYPES as readonly string[]).includes(t)
}

export function unsupportedChartMessage(t: string): string {
  return `Chart type "${t}" is not supported yet.`
}
